import { createSlice, CaseReducer, createAsyncThunk } from '@reduxjs/toolkit';

import { get } from 'api/requests';

import { IParamsReq, Responce } from 'types';
import {
  DeliveryScheduleStruct,
  DeliveryScheduleStore,
} from 'pages/DeliverySchedule/ApartmentDeliverySchedule/types';

const initialState: DeliveryScheduleStore = {
  count: 0,
  currentRequestId: undefined,
  data: [],
  loading: false,
  noData: false,
};

const reset: CaseReducer<DeliveryScheduleStore> = () => initialState;

export const deliveryScheduleSlice = createSlice({
  name: 'deliverySchedule',
  initialState,
  reducers: {
    reset,
  },
  extraReducers: builder => {
    builder
      .addCase(getDeliverySchedule.pending, (state, action) => {
        state.loading = true;
        state.currentRequestId = action.meta.requestId;
      })
      .addCase(getDeliverySchedule.fulfilled, (state, { payload }) => {
        state.loading = false;

        if (payload) {
          const { results, count } = payload;
          state.data = results;
          state.count = count;
          state.noData = results.length === 0;
        }
      })
      .addCase(getDeliverySchedule.rejected, (state, action) => {
        const { requestId } = action.meta;

        if (state.loading === true && state.currentRequestId === requestId) {
          state.loading = false;
        }
      });
  },
});

export const { reset: setReset } = deliveryScheduleSlice.actions;

export const getDeliverySchedule = createAsyncThunk(
  'planTransferOvp/getPlanTransferOvp',
  async (params: IParamsReq, thinkApi) => {
    try {
      const { data } = await get<Responce<DeliveryScheduleStruct>>(
        '/api/v2/settlement/plan/summary/',
        params,
      );
      return data;
    } catch (error) {
      return thinkApi.rejectWithValue(error);
    }
  },
);
